/** Full-viewport branded splash while auth or allowlist gates resolve. */
export function AuthLoadingSplash() {
  return (
    <div className="splash-screen">
      <img src="/watchlist-mark.svg" alt="Watchlist" className="splash-logo" />
    </div>
  );
}
